import React from 'react';

import { reviewAbridgedPropTypeShape } from '../../../../proptypes';

import Avatar from '../../../Avatar';
import ReadMore from '../../../ReadMore';
import StarRating from '../../../StarRating';

import {
  avatar,
  description as descriptionStyle,
  header,
  name,
} from './styles.module.css';

/**
 * Review list item presentational component.
 */
const ReviewListItem = ({
  author,
  race,
  ratings,
  review,
  year,
  createdAt,
}) => (
  <article>
    <div>
      <header className={header}>
        <Avatar user={{ ...author, pictureUrl: author.picture }} className={avatar} />
        <div>
          <h3 className={name}>{author.displayName}</h3>
          <StarRating value={ratings.overall} small />
          <p className={descriptionStyle}>Did the {race.title} in {year}</p>
          <meta content={createdAt} />
        </div>
      </header>
      <div>
        <ReadMore content={review} html className={descriptionStyle} />
      </div>
    </div>
  </article>
);

ReviewListItem.propTypes = {
  /**
   * Author object of the reviewer.
   */
  author: reviewAbridgedPropTypeShape.author, // eslint-disable-line react/require-default-props
  /**
   * Race object for review.
   */
  race: reviewAbridgedPropTypeShape.race, // eslint-disable-line react/require-default-props
  /**
   * Ratings object for review.
   */
  ratings: reviewAbridgedPropTypeShape.ratings, // eslint-disable-line react/require-default-props
  /**
   * String of full review.
   */
  review: reviewAbridgedPropTypeShape.review, // eslint-disable-line react/require-default-props
  /**
   * createdAt string of full review.
   */
  createdAt: reviewAbridgedPropTypeShape.string,
  /**
   * Numeric year of the reviewed race.
   */
  year: reviewAbridgedPropTypeShape.year, // eslint-disable-line react/require-default-props
};

ReviewListItem.defaultProps = {
  createdAt: undefined,
};

export default ReviewListItem;



// WEBPACK FOOTER //
// ./app/src/components/ReviewList/components/ReviewListItem/index.jsx